<template lang="pug">
  div
    div(v-if='!rendered', style='display:none')
      component(id="test",:is='icon',:size='128')
      canvas(:width='iconWidth',:height='iconHeight')
    slot(name='children'
        v-bind:childComponent='childComponent',
        v-bind:parentHolder='holder',
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')
    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:context='context',
        v-bind:depth='depth',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='sprite.sprite')
    //get-container-bounds(v-if='rendered',:container='innerContainer')
      template(#default="{bounds}")
        overlay.-m-2(:bounds='bounds', @click='lol')
</template>
<script>
import DelayOverlay from '@ui/molecules/DelayOverlay.vue';
import RandomOverlay from '@ui/molecules/RandomOverlay.vue';
import OnEventOverlay from '@ui/molecules/OnEventOverlay.vue';
import GridTransformOverlay from '@ui/molecules/GridTransformOverlay.vue';
import SpawnerOverlay from '@ui/molecules/SpawnerOverlay.vue';
import Overlay from '@edit/atoms/Overlay.vue';
import GetContainerBounds from '@edit/atoms/GetContainerBounds.vue';
import Holder from '@edit/render/holder.js';
import Loader from '@/edit/loader.js';
import EventEmitter from 'eventemitter3';


import CameraIcon from '@icons/Camera.vue';


export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    innerContainer:{
      type:Object,
      required:true
    },
    outerContainer:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    depth:{
      type:Number,
      required:true
    },
    holder:{
      type:Object,
      required:true
    },
    context: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    let showLabel = false;
    const component = this.partutil.findComponentForTransform(this.transform);
    let icon = CameraIcon;

    return {
      component,
      showLabel,
      icon,
      rendered: false,
      iconColor: '#ffff00',
      iconWidth: 128,
      iconHeight: 128
    }
  },
  components:{
    Overlay,
    GetContainerBounds
  },
  mounted() {
      const svgEl = this.$el.querySelector('.material-design-icon__svg');
      const lol = svgEl.querySelector('path');
      lol.setAttribute('fill', this.iconColor);
      var svgString = new XMLSerializer().serializeToString(svgEl);
      var canvas = this.$el.querySelector('canvas');
      var ctx = canvas.getContext("2d");
      var DOMURL = window.URL || window.webkitURL || window;
      var img = new Image();
      var svg = new Blob([svgString], {type: "image/svg+xml"});
      var url = DOMURL.createObjectURL(svg);
      img.onload = () => {
        if (this.destroyed) {
          return;
        }
        ctx.drawImage(img, 0, 0);
        var png = canvas.toDataURL("image/png");

        this.sprite = new Camera(png, this.renderTools, this.innerContainer, this.transform, this.component, this.iconColor, [this.iconWidth, this.iconHeight]);
        this.sprite.events.on("loaded", () => {
          this.rendered = true;
          this.$emit("loaded");
        });
        this.renderTools.addToEnterBatch(this.sprite);

        DOMURL.revokeObjectURL(png);
      };
      img.onerror = (err, lal, lel) => {
        console.error('am error', err, lal, lel);
      }
      img.src = url;

  },
  methods:{
  },
  beforeDestroy() {
    this.destroyed = true;
    if (this.sprite && this.sprite.events) {
      this.sprite.events.off("loaded");
    }
    if (this.sprite && this.sprite.exit) {
      if (this.renderTools) {
        this.renderTools.addToExitBatch(this.sprite);
      }
    }
  },
  computed:{
    childComponent() {
      if (this.component.type === "delayTransform") {
        return DelayOverlay;
      } else if (this.component.type === "randomTransform") {
        return RandomOverlay;
      } else if (this.component.type === "onEventTransform") {
        return OnEventOverlay;
      } else if (this.component.type === "gridTransform") {
        return GridTransformOverlay;
      } else if (this.component.type === "spawner") {
        return SpawnerOverlay;
      } else {
        return null;
      }
    }
  },
  watch:{
  }
}

function Camera(img, renderTools, parentContainer, transform, data, iconColor, dims) {
  this.img = PIXI.Texture.from(img);
  this.renderTools = renderTools;
  this.parentContainer = parentContainer;
  this.transform = transform;
  this.data = data;
  this.alpha = 1;
  this.sprite = new PIXI.Sprite();
  this.loading = true;
  this.events = new EventEmitter();

  this.iconColor = iconColor;
  this.iconWidth = dims[0];
  this.iconHeight = dims[1];
}
Camera.prototype.getUrl = function (img) {
  return this.renderTools.makeImageUrl(img);
}
Camera.prototype.enter = function () {
  const img = this.img
  const x = this.transform.transform.pos.x;
  const y = this.transform.transform.pos.y;
  const rotation = this.transform.transform.rotation;
  const scale = this.transform.transform.scale;

  this.renderTools.addToWaitBatch(this.waiting.bind(this));

  //this.myContainer = this.parentContainer;
  this.myContainer = new PIXI.Container();
  this.myContainer.addChild(this.sprite);

  this.sprite.anchor.set(0.5, 0.5);

  this.graphics = new PIXI.Graphics();
  //this.myContainer.addChild(this.graphics);

  //this.myContainer.disableInteraction();

  this.rectangle = new PIXI.Graphics();
  this.rectangle.lineStyle(16, this.iconColor.replace('#', '0x'));
  const perc = 1.3;
  this.rectangle.drawRect(perc * -this.iconWidth/2, perc * -this.iconHeight/2, perc * this.iconWidth, perc * this.iconHeight);
  this.rectangle.endFill();
  this.myContainer.addChild(this.rectangle);

  this.loadImage();

  this.renderTools.addToUpdateBatch(this);

}

Camera.prototype.loadImage = function () {
  const texture = this.img;
  const sprite = this.sprite;
  sprite.texture = this.img;
  const textureWidth = this.iconWidth;
  const textureHeight = this.iconHeight;
  const unit = this.renderTools.worldToScreen({x:1, y:1});
  sprite.scale.x = unit.x / textureWidth;
  sprite.scale.y = unit.y / textureHeight;

  this.loading = false;

}

Camera.prototype.waiting = function () {
  if (!this.myContainer) {
    return;
  }
  if (this.destroyed) {
    return;
  }

  if (!this.loading) {
    this.events.emit("loaded");
  } else {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  }
}

Camera.prototype.getSquare = function () {
  const x = this.object.transform.scale.x;
  const y = this.object.transform.scale.y;
  return {
    x1:-x/2,
    x2:x/2,
    y1:-y/2,
    y2:y/2
  }
}
Camera.prototype.getScaleThingy = function () {
  return this.object.transform.scale;
}
Camera.prototype.onSelect = function (event) {
  this.events.emit('select-transform', event);
}
Camera.prototype.update = function () {
  //this.myContainer.disableInteraction();

  if (this.transform.transform.anchor) {
    const sprite = this.sprite;
    sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }

  const parts = this.data.aspect.split('x');
  let x = parseInt(parts[0]) * (this.data.zoom||1);
  let y = parseInt(parts[1]) * (this.data.zoom||1);
  x = this.renderTools.worldToScreen_x(x);
  y = this.renderTools.worldToScreen_y(y);

  this.graphics.cacheAsBitmap = false;
  this.graphics.clear();
  this.graphics.lineStyle(0.05, 0xff00ff,0.2)
  this.graphics.beginFill(0xcecece,0.2);
  this.graphics.drawRect(-x/2,-y/2,x,y);
  this.graphics.endFill();

  this.graphics.cacheAsBitmap = true;
}

Camera.prototype.exit = function () {
  this.destroyed = true;
  try {
    this.sprite.destroy();
  } catch (e) {
  }
  try {
    this.myContainer.destroy({
      children:true,
    })
  } catch (e) {
  }
  try {
    this.container.removeChild(this.myContainer);
  } catch (e) {
  }
}



</script>
<style>
.icon-svg {
  stroke: blue !important;
  stroke-width:4px !important;
  outline: 3px solid green !important;
}
</style>
